/**
 * Shared NATS/JetStream tuning constants.
 *
 * Kept in one place so every data path (the motor Web Worker, the main-thread
 * dashboard providers, energy) uses the same values — no more setting the same
 * timeout in several files.
 */

/**
 * Timeout for JetStream management / consumer-create operations.
 *
 * Large edge servers (e.g. edge-16) expose thousands of subjects, so
 * stream-info and consumer creation routinely exceed the nats.ws 5 s default.
 * 30 s gives those calls room without hanging the UI indefinitely.
 */
export const JETSTREAM_OP_TIMEOUT_MS = 30_000;
